// this is a hack to improve DX
// TODO: figure out a better way

const { Auth0 } = require("./dist/auth0")
module.exports = { Auth0 }
